import SocialCard from './SocialCard';

export default SocialCard;
